import React from 'react'
import { DndProvider } from 'react-dnd'
import { BackendFactory } from 'dnd-core'
import { MouseTransition, MultiBackend, TouchTransition } from 'react-dnd-multi-backend'
import { TouchBackend } from 'react-dnd-touch-backend'
import { HTML5Backend } from 'react-dnd-html5-backend'

import environment from 'environment'

export const getDndBackendAndOptions = () => {}

type Props = {
  backend?: BackendFactory
  options?: unknown // BackendOptions
  delayTouchStart?: number
  touchSlop?: number
  children: React.ReactNode
}

const DragDropProvider = ({ children, options, backend, delayTouchStart = 0, touchSlop = 0 }: Props) => {
  const defaultOptions = { backends: new Array<any>() }

  // This backend causes terrible lag, but there's a strange bug in Firefox without it so they can deal with the lag
  if (environment.getIsFirefox()) {
    defaultOptions.backends.push({
      id: 'html5',
      backend: HTML5Backend,
      transition: MouseTransition,
      preview: false,
    })
  }

  defaultOptions.backends.push({
    id: 'touch',
    backend: TouchBackend,
    options: { enableMouseEvents: true, touchSlop: 5 },
    transition: TouchTransition,
  })

  return (
    <DndProvider
      context={typeof window !== 'undefined' ? window : undefined}
      backend={backend || MultiBackend}
      options={options || defaultOptions}>
      {children}
    </DndProvider>
  )
}

export default DragDropProvider
